/**
 * Chế độ build của app, đọc từ biến môi trường APP_MODE lúc build.
 * - không đặt: CRM An Vui đầy đủ (mặc định)
 * - 'lhv': trang quản trị riêng cho Loa Heo Vàng, chỉ có menu /partner-devices
 *
 * File này được import ở cả config (Node) lẫn client (qua define 'process.env').
 */
export const isLHVMode = process.env.APP_MODE === 'lhv';
